import objects from '../recorders/objects';
import capitalLetter from '../../utilities/capital-letter';
import { getFareFamilyForAnalytics } from '../utils/global-utils';

function productClick(ancillaryToTracking, isWithPoints, userProfile, seatExitRow, pnrInfo) {
  const flightType = getFlightType(ancillaryToTracking.flightType);
  const flightCategory = getFlightCategory(ancillaryToTracking.marketFlight, ancillaryToTracking.region);
  const familyFare = getFareFamilyForAnalytics(ancillaryToTracking.fareFamily) !== undefined ? getFareFamilyForAnalytics(ancillaryToTracking.fareFamily) : 'NA';
  const category = `Seat/Ancillary/${ancillaryToTracking.route}/${familyFare}/${flightType}-${flightCategory}`;
  const dataToTracking = {
    actionField: { list: 'Seatmap MYB' },
    products: [
      {
        name: ancillaryToTracking.ancillary.item.name,
        id: ancillaryToTracking.ancillary.item.id,
        price: ancillaryToTracking.ancillary.item.price,
        brand: ancillaryToTracking.ancillary.item.brand,
        category: category,
        variant: 'NA',
        position: ancillaryToTracking.ancillary.item.position,
      },
    ],
  };

  if (isWithPoints && ancillaryToTracking.balance) {
    dataToTracking.balance = ancillaryToTracking.balance;
  }

  return objects.ecommerce.productClick(dataToTracking, userProfile, seatExitRow, pnrInfo);
}

function getDataToTrackingForProduct(product) {
  const flightType = getFlightType(product.flightType);
  const flightCategory = getFlightCategory(product.marketFlight, product.region);
  const familyFare = getFareFamilyForAnalytics(product.fareFamily) !== undefined ? getFareFamilyForAnalytics(product.fareFamily) : 'NA';
  const category = `Seat/Ancillary/${product.route}/${familyFare}/${flightType}-${flightCategory}`;

  const dataToTracking = {
    currencyCode: product.ancillaries[0].currencyCode,
    balance: product.balance,
    products: product.ancillaries.map(ancillary => {
      return {
        name: ancillary.item.name,
        id: ancillary.item.id,
        price: ancillary.item.price,
        brand: ancillary.item.brand,
        category: category,
        variant: 'NA',
        quantity: ancillary.item.quantity,
      };
    }),
  };
  return dataToTracking;
}

function getProductData(product) {
  const flightType = getFlightType(product?.flightType);
  const flightCategory = getFlightCategory(product?.marketFlight, product?.region);
  const familyFare = getFareFamilyForAnalytics(product?.fareFamily) !== undefined ? getFareFamilyForAnalytics(product?.fareFamily) : 'NA';
  const category = `Seat/Ancillary/${product?.route}/${familyFare}/${flightType}-${flightCategory}`;
  const dataToTracking = [];
  dataToTracking.push({
    currencyCode: product?.ancillaries?.[0]?.currencyCode,
    balance: product?.balance,
    products: (product?.ancillaries || []).map(ancillary => {
      return {
        name: ancillary?.item?.name,
        id: ancillary?.item?.id,
        price: ancillary?.item?.price,
        points: ancillary?.item?.points,
        brand: ancillary?.item?.brand,
        category: category,
        variant: 'NA',
        quantity: ancillary?.item?.quantity,
      };
    }),
  });
  return dataToTracking;
}

function addProductToCart(productToAdd, pnrInfo, userProfile, seatExitRow) {
  const dataToTracking = getDataToTrackingForProduct(productToAdd);
  return objects.ecommerce.addProductToCart(dataToTracking, pnrInfo, userProfile, seatExitRow);
}

function addToCart(pnrInfo, trackingDataForSeat, userProfile, isActiveFlowCorporate, userCorporate) {
  const dataToTracking = [];
  trackingDataForSeat.forEach((product) => {
    dataToTracking.push(getProductData(product));
  });
  return objects.ecommerce.seatAddToCart(dataToTracking, pnrInfo, userProfile, isActiveFlowCorporate, userCorporate);
}

function removeProductFromCart(productToRemove) {
  const dataToTracking = getDataToTrackingForProduct(productToRemove);
  return objects.ecommerce.removeProductFromCart(dataToTracking);
}
function journeySuccess(pnrInfo, subFunnel, userProfile, allPassengers, isActiveFlowCorporate) {
  return objects.ecommerce.journeySuccess(pnrInfo, subFunnel, userProfile, allPassengers, isActiveFlowCorporate);
}

export const getFlightCategory = (marketFlight, region) => {
  switch (marketFlight.toLowerCase()) {
    case 'domestic':
      return capitalLetter(marketFlight);
    case 'transborder':
      return `${capitalLetter(marketFlight)} ${region.substring(0, 2).toUpperCase()}`;
    case 'sudamerica_asia':
      return 'AyS';
    case 'europa':
      return 'Europe';
    case 'centroamerica_caribe':
      return 'CyC';
  }
};

export const getFlightType = tripType => {
  return tripType && tripType === 'ROUNDTRIP' ? 'RT' : tripType && tripType === 'ONEWAY' ? 'OW' : 'MC';
};

export const seatsViewList = (pnrInfo, seatsData, indexFlight, sections) => {
  return objects.ecommerce.seatsSchema(pnrInfo, seatsData, indexFlight, sections);
};

export default {
  addToCart,
  addProductToCart,
  productClick,
  removeProductFromCart,
  journeySuccess,
  seatsViewList,
};